import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ModalBasic from "../components/ModalBasic";
import ModalLoading from "../components/ModalLoading";
import { HEADER } from "../utils/Utils";
import { requestPost } from "../api/coreInstance";
import withAuth from "../components/withAuth";

const AdminLogin = () => {
   const [email, setEmail] = useState("");
   const [isSent, setIsSent] = useState(true);
   const [isOtpRequire, setIsOtpRequire] = useState(false);
   const [showModal, setShowModal] = useState(false);
   const [showModalLoading, setShowModalLoading] = useState(false);

   const navigate = useNavigate();
   const [otp, setOtp] = useState([]);
   const [counter, setCounter] = useState(30);
   // navigate
   // location

   useEffect(() => {
      const timer =
         counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
   }, [counter]);

   const handleChange = (e) => {
      var target = e.srcElement || e.target;
      var maxLength = parseInt(target.attributes["maxlength"].value, 10);
      var myLength = target.value.length;
      var value = [];
      value = otp;

      if (myLength >= maxLength) {
         value.push(e.target.value);

         var next = target;
         while ((next = next.nextElementSibling)) {
            if (next == null) {
               break;
            }
            if (next.tagName.toLowerCase() === "input") {
               next.focus();
               break;
            }
         }
      }
      // Move to previous field if empty (user pressed backspace)
      else if (myLength === 0) {
         value.pop();
         var previous = target;
         while ((previous = previous.previousElementSibling)) {
            if (previous == null) {
               break;
            }
            if (previous.tagName.toLowerCase() === "input") {
               previous.focus();
               break;
            }
         }
      }

      setOtp(value);
      if (value.length === 4) {
         ConfirmOTP(e);
      }
   };

   function ConfirmOTP(e) {
      setShowModalLoading(true);
      var code = _.join(otp, "");
      e.preventDefault();
      requestPost(
         `/v2/account/signin/ppv/verification`, JSON.stringify({
            param: email,
            code: code,
         })
      )
         .then((res) => {
            if (Object.keys(res.data.data).length > 0) {
               setShowModalLoading(false);
               localStorage.setItem("dompet_user", JSON.stringify(res.data.data));
               navigate("/dashboard", { state: { email } });
            } else {
               setShowModalLoading(false);
               setShowModal(true);
            }
         })
         .catch((error) => {
            console.error("Error:", error);
         });
   }

   function Signin(e) {
      e.preventDefault();
      setShowModalLoading(true);
         requestPost(`/v2/account/signin/ppv/index`,JSON.stringify({ param: email })
      )
         .then((res) => {
            if (res.data.data.sent) {
               setShowModalLoading(false);
               // setShowModal(true);
               setIsSent(true);
               setIsOtpRequire(true);
               //   setTimeout(navigate("/confirm-otp", { state: { email } }), 2000);
            } else {
               setShowModalLoading(false);
               setIsSent(false);
               // setShowModal(true);
            }
         })
         .catch((error) => {
            setShowModalLoading(false);
            setIsSent(false);
            // setShowModal(true);
            console.error("Error:", error);
         });
   }

   return (
      <>
         <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
         />
         <ModalBasic
            id="message-confirm-modal"
            modalOpen={showModal}
            setModalOpen={setShowModal}
            title="Confirm Message"
            enClose={true}
         >
            <div className="px-5 py-4">
               {isSent ? (
                  <p className="text-gray-500">
                     Success sent otp to{" "}
                     <span className="text-indigo-500 font-medium">
                        {email}
                     </span>
                  </p>
               ) : (
                  <p className="text-gray-500">
                     Failed sent otp to{" "}
                     <span className="text-indigo-500 font-medium">
                        {email}
                     </span>
                  </p>
               )}
            </div>
         </ModalBasic>
         <main className="flex items-center justify-center min-h-screen">
            {/* <div className="h-screen bg-black"></div> */}
            <div className="px-12 py-12 shadow bg-white rounded-t-lg">
               {isOtpRequire ? (
                  <div className="  bg-white">
                     <p className="text-gray-800 text-center mb-6">
                        OTP code is sent to your email
                     </p>
                     {/* Form */}
                     <form>
                        <div className="w-72 space-y-4">
                           <div className="otp flex justify-between space-x-5">
                              <input
                                 id="0"
                                 className="form-input w-full text-center font-bold text-gray-800 text-3xl h-14"
                                 type="number"
                                 maxLength={1}
                                 onChange={handleChange}
                              />
                              <input
                                 id="1"
                                 className="form-input w-full text-center font-bold text-gray-800 text-3xl h-14"
                                 type="number"
                                 maxLength={1}
                                 onChange={handleChange}
                              />
                              <input
                                 id="2"
                                 className="form-input w-full text-center font-bold text-gray-800 text-3xl h-14"
                                 type="number"
                                 maxLength={1}
                                 onChange={handleChange}
                              />
                              <input
                                 id="3"
                                 className="form-input w-full text-center font-bold text-gray-800 text-3xl h-14"
                                 type="number"
                                 maxLength={1}
                                 onChange={handleChange}
                              />
                           </div>
                        </div>
                        <div className="flex flex-col mt-6 space-y-2">
                           <button
                              className="btn-lg bg-[#CCCCCC] hover:bg-indigo-600 text-white"
                              aria-controls="basic-modal"
                              onClick={(e) => ConfirmOTP(e)}
                           >
                              CONFIRM OTP
                           </button>
                        </div>
                        <div className="pt-5">
                           <div className="text-sm text-center">
                              Didn't recive otp code?
                              <Link
                                 className="font-medium text-indigo-500 hover:text-indigo-600"
                                 to="/signin"
                              >
                                 {`${
                                    counter === 0
                                       ? " Resend Code"
                                       : " " + counter
                                 }`}
                              </Link>
                           </div>
                        </div>
                     </form>
                  </div>
               ) : (
                  <>
                     <h1 className="text-3xl text-gray-800 font-bold mb-6">
                        Welcome to Kartini! ✨
                     </h1>
                     {/* Form */}
                     <form>
                        <div className="space-y-4">
                           <div>
                              <input
                                 id="email"
                                 placeholder="Email"
                                 className={`form-input w-full h-12 ${
                                    !isSent && "border-red-300"
                                 }`}
                                 onChange={(e) => setEmail(e.target.value)}
                                 type="email"
                              />
                              {!isSent && (
                                 <div className="text-xs mt-1 text-red-500">
                                    E-mail not registered!
                                 </div>
                              )}
                           </div>
                        </div>
                        <div className="flex flex-col mt-6 space-y-2">
                           <button
                              className="btn-lg w-full bg-[#CCCCCC] text-[#7D7C7C]"
                              onClick={(e) => Signin(e)}
                           >
                              Sign In
                           </button>
                        </div>
                     </form>
                  </>
               )}
            </div>
         </main>
      </>
   );
}

export default withAuth(AdminLogin, { protectedRoute: false })